import React, { useState, useEffect } from 'react';
import axios from 'axios';

const FAQManagement = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [formData, setFormData] = useState({
    question: '',
    answer: '',
    category: 'General',
    tags: '',
    display_order: 0
  });

  useEffect(() => {
    fetchFaqs();
  }, []);

  const fetchFaqs = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.get('/api/admin/faqs', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFaqs(response.data);
      setLoading(false);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to load FAQs');
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const token = localStorage.getItem('adminToken');

      if (editingId) {
        await axios.put(`/api/admin/faqs/${editingId}`, formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axios.post('/api/admin/faqs', formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }

      setFormData({
        question: '',
        answer: '',
        category: 'General',
        tags: '',
        display_order: 0
      });
      setEditingId(null);
      setShowAddForm(false);
      fetchFaqs();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to save FAQ');
    }
  };

  const handleEdit = (faq) => {
    setFormData({
      question: faq.question,
      answer: faq.answer,
      category: faq.category || 'General',
      tags: faq.tags || '',
      display_order: faq.display_order || 0
    });
    setEditingId(faq.id);
    setShowAddForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this FAQ?')) {
      return;
    }

    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`/api/admin/faqs/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchFaqs();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to delete FAQ');
    }
  };

  const handleCancel = () => {
    setFormData({
      question: '',
      answer: '',
      category: 'General',
      tags: '',
      display_order: 0
    });
    setEditingId(null);
    setShowAddForm(false);
    setError('');
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2rem' }}>
        <h1>FAQ Management</h1>
        {!showAddForm && (
          <button onClick={() => setShowAddForm(true)} style={{ padding: '0.75rem 1.5rem', background: '#4A90E2', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>
            Add New FAQ
          </button>
        )}
      </div>

      {error && <div style={{ padding: '1rem', background: '#ffebee', color: '#c62828', borderRadius: '6px', marginBottom: '1rem' }}>{error}</div>}

      {showAddForm && (
        <div style={{ background: 'white', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <h2>{editingId ? 'Edit FAQ' : 'Add New FAQ'}</h2>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Question *</label>
              <input type="text" value={formData.question} onChange={(e) => setFormData({ ...formData, question: e.target.value })} required style={{ width: '100%', padding: '0.5rem', border: '1px solid #e0e0e0', borderRadius: '4px', boxSizing: 'border-box' }} />
            </div>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Answer *</label>
              <textarea value={formData.answer} onChange={(e) => setFormData({ ...formData, answer: e.target.value })} required rows={5} style={{ width: '100%', padding: '0.5rem', border: '1px solid #e0e0e0', borderRadius: '4px', boxSizing: 'border-box', fontFamily: 'inherit' }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem', marginBottom: '1rem' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Category</label>
                <input type="text" value={formData.category} onChange={(e) => setFormData({ ...formData, category: e.target.value })} style={{ width: '100%', padding: '0.5rem', border: '1px solid #e0e0e0', borderRadius: '4px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Tags</label>
                <input type="text" value={formData.tags} onChange={(e) => setFormData({ ...formData, tags: e.target.value })} placeholder="comma-separated" style={{ width: '100%', padding: '0.5rem', border: '1px solid #e0e0e0', borderRadius: '4px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Order</label>
                <input type="number" value={formData.display_order} onChange={(e) => setFormData({ ...formData, display_order: parseInt(e.target.value) || 0 })} style={{ width: '100%', padding: '0.5rem', border: '1px solid #e0e0e0', borderRadius: '4px', boxSizing: 'border-box' }} />
              </div>
            </div>
            <div style={{ marginBottom: '1rem', padding: '1rem', background: '#f5f5f5', borderRadius: '4px', border: '1px solid #e0e0e0' }}>
              <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={formData.is_major}
                  onChange={(e) => setFormData({ ...formData, is_major: e.target.checked })}
                  style={{ marginRight: '0.75rem', width: '18px', height: '18px', cursor: 'pointer' }}
                />
                <div>
                  <span style={{ fontWeight: '600', fontSize: '1rem' }}>Show to all clients</span>
                  <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.85rem', color: '#666' }}>When checked, this FAQ will be visible in the client portal. Uncheck to hide from clients.</p>
                </div>
              </label>
            </div>
            <button type="submit" style={{ padding: '0.75rem 1.5rem', background: '#4A90E2', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', marginRight: '0.5rem' }}>{editingId ? 'Update' : 'Create'}</button>
            <button type="button" onClick={handleCancel} style={{ padding: '0.75rem 1.5rem', background: 'white', color: '#666', border: '1px solid #e0e0e0', borderRadius: '6px', cursor: 'pointer' }}>Cancel</button>
          </form>
        </div>
      )}

      <div style={{ display: 'grid', gap: '1rem' }}>
        {faqs.map((faq) => (
          <div key={faq.id} style={{ background: 'white', padding: '1.5rem', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
              <div style={{ flex: 1 }}>
                <h3 style={{ margin: '0 0 0.5rem 0' }}>{faq.question}</h3>
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
                  <span style={{ padding: '0.25rem 0.75rem', background: '#e3f2fd', color: '#4A90E2', borderRadius: '12px', fontSize: '0.8rem' }}>{faq.category}</span>
                  {faq.is_major && (
                    <span style={{ padding: "0.25rem 0.75rem", background: "#c8e6c9", color: "#2e7d32", borderRadius: "12px", fontSize: "0.75rem", fontWeight: "600" }}>VISIBLE TO CLIENTS</span>
                  )}
                  {!faq.is_major && (
                    <span style={{ padding: "0.25rem 0.75rem", background: "#ffecb3", color: "#f57c00", borderRadius: "12px", fontSize: "0.75rem", fontWeight: "600" }}>HIDDEN FROM CLIENTS</span>
                  )}
                  {faq.tags && faq.tags.split(',').map((tag, idx) => (
                    <span key={idx} style={{ padding: '0.25rem 0.75rem', background: '#f5f5f5', color: '#666', borderRadius: '12px', fontSize: '0.75rem' }}>{tag.trim()}</span>
                  ))}
                </div>
              </div>
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <button onClick={() => handleEdit(faq)} style={{ padding: '0.5rem 1rem', background: '#4A90E2', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Edit</button>
                <button onClick={() => handleDelete(faq.id)} style={{ padding: '0.5rem 1rem', background: '#c62828', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Delete</button>
              </div>
            </div>
            <p style={{ margin: '0', color: '#666', lineHeight: '1.6' }}>{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQManagement;
